module.exports = __webpack_public_path__ + "3b973a05c0e1544f7ee8fa23c2a9315a.ttf";